import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/configuracoes/tarifa-cartao')({
  component: lazyRouteComponent(
    () => import('@/features/configuracoes/components/tarifa-cartao-tab'),
    'TarifaCartaoTab'
  ),
})
